import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";

 const CreateNewWebPage= ({closePagePopUp,onClickCreate})=>{
    // const {category} = useParams();
   

    const App = useSelector((state)=>state?.app?.app);
    const [Courses,setCourses] =useState([])
    const [CoursesBlank,setCoursesBlank] =useState([{},{},{},{},{}])
     const [animate, setAnimate] = useState(false);
     
    const dispatch = useDispatch();  
  
    const currentToken = useSelector((state)=>state?.user?.user?.token);
    const user_email = useSelector((state)=>state?.user?.user?.user_email
   );
   const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
   const appId = useSelector((state)=>state?.app?.app?.ID);
   const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
        
   const [snackbarVisible, setSnackbarVisible] = useState(false);
    
    const [snackbarColor, setSnackbarColor] = useState("#958FDA");
    const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
    const showSnackbar = () => {
     setSnackbarVisible(true);
   };
   
    const hideSnackbar = () => {
     setSnackbarVisible(false);
   };
   const setCurrentCourse=()=>{
    dispatch({
        type: "COURSEDATA",
        
        payload:""
      });  
}
       const [loader , setLoader] =useState({status:false});
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
          {
            
            dispatch({type: "CURSOR",payload:true  });
        
            dispatch({type: "CURSORTEXT",payload:CursorText})
            dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
            dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
          }
           
          const handleMouseLeave = () => {
            
            dispatch({type: "CURSOR",payload:false})
        
            dispatch({type: "CURSORTEXT",payload:""})
        
            dispatch({type: "CURSORTEXTBG",payload:""})
            dispatch({type: "CURSORTEXTCOLOR",payload:""})
          
        
        } 
    
        
        const [pageName, setPageName] = useState("");
       
        const [fireConfetti, setFireConfetti] = useState(false);
        
    const userdata = useSelector((state)=>state?.user?.user);
    useEffect(()=>{
      
     
     },[])
   useEffect(()=>{

   },[])
   
    
       
   
       return <>
       
   
 
 <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{zIndex:99,cursor:"pointer"}} onClick={()=>closePagePopUp(false)} className="appDesignPopUpOpacity"> </div>
        <div   className="AreYouSurePopUp" style={{height:"400px",borderRadius: '20px'}}> 
        <h2 align="center" >   Create  A New <span className="coloredTextV1" > Page</span> </h2>
      
 
<div className="bookmarkListScroll" style={{overflowY:"auto",height:"280px",overflowX:"hidden"}}>

    <div className="">
    
  
   <div >
    
<div style={{} }>
<div  className="" >
<div  className="ikcraft_login-input-card">
 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"25px"}} placeholder={`Add Page Name`} type="text"
  rows={2} name="courseTitle" value={pageName} onChange={(e)=>setPageName(e.target.value)} />
 </div></div>
 

 </div>

</div>





</div>

<div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"18px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{closePagePopUp(false)}}   className=" CoursesPreviewTopBtn"  type="submit"
 > Cancel </button>
<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{onClickCreate(pageName);closePagePopUp(false)}}  style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 >Create New Page</button>
</div> 
</div>

     </div>

       <div>
     </div>

    
     
     </>


}
export default CreateNewWebPage;